<template>
  <div>
    <!-- 头部模板 -->
    <header-yjj-m></header-yjj-m>

    <!--  内容页  -->
    <!--  轮播图  -->
    <div class="slide-img" ref="slide">
      <img id="slideImg" src="../../../assets/slide-1.jpg" ref="slideImg">
    </div>
<!--    <div style="margin-top: -4px;">-->
<!--      <van-notice-bar left-icon="volume-o"  color="rgb(184,134,97)" background="rgb(245,245,245)" scrollable>-->
<!--        <span  v-for="(item,index) in noticeList" :key="item.index" style="margin-right: 100px;">-->
<!--            <router-link :to="{name:'ArticleContentYjj',params:{id:item.id,prevNav:'HomeYjj'}}" style="padding-left: 20px;">-->
<!--              {{index+1}}、{{ item.title }}-->
<!--            </router-link>-->
<!--        </span>-->
<!--      </van-notice-bar>-->
<!--    </div>-->

    <div style="margin-top: 20px;padding-bottom: 20px;">
      <h3 class="news-nav-title" style="padding:0 15px;">
        <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
        <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
        纪念馆开馆时间
      </h3>
      <div style="display: flex;margin-top:20px;font-size: 14px;">
        <div style="flex:2">
          <span style="font-size: 18px;">{{ this.yjjdata.date1 }}</span>

          <p style="margin-top: 3px;">开馆时间</p>
        </div>
        <div style="flex:1">
<!--          <img src="../../../assets/jiantou-m.png" style="width:100%;position: relative;top:10px;">-->
        </div>
        <div style="flex:2">
          <span style="font-size: 18px;">{{ this.yjjdata.date2 }}</span>
          <p style="margin-top: 3px;">停止入馆时间</p>
        </div>
        <div style="flex:1">
<!--          <img src="../../../assets/jiantou-m.png" style="width:100%;position: relative;top:10px;">-->
        </div>
        <div style="flex:2">
          <span style="font-size: 18px;">{{ this.yjjdata.date3 }}</span>
          <p style="margin-top: 3px;">闭馆时间</p>
        </div>
      </div>
      <div style="font-size: 13px;margin-top: 10px;">
        （温馨提示：{{ this.yjjdata.abstr }}）
      </div>
      <van-divider dashed :style="{ color: '#1989fa', borderColor: 'rgb(184,134,97)', padding: '0 26px' }"></van-divider>
      <div style="display: flex;font-size: 14px;">
        <div style="flex: 1" @click="showKai()">
          <van-icon name="completed" color="rgb(184,134,97)" size="2rem"  style="border: 2px solid rgb(184,134,97);border-radius: 50%;padding:5px;"  />
          <p style="margin-top: 5px;">开馆状态</p>
        </div>
        <div style="flex: 1">
          <router-link :to="{name:'ArticleContentYjj',params:{id:'1680465689259765865',prevNav:'HomeYjj'}}">
            <van-icon name="todo-list" color="rgb(184,134,97)" size="2rem"  style="border: 2px solid rgb(184,134,97);border-radius: 50%;padding:5px;" />
            <p style="margin-top: 5px;">预约讲解</p>
          </router-link>
        </div>
        <div style="flex: 1">
          <router-link :to="{name:'ArticleContentYjj',params:{id:'1680465689259765864',prevNav:'HomeYjj'}}">
            <van-icon name="notes" color="rgb(184,134,97)" size="2rem"  style="border: 2px solid rgb(184,134,97);border-radius: 50%;padding:5px;" />
            <p style="margin-top: 5px;">参观须知</p>
          </router-link>
        </div>
        <div style="flex: 1">
          <router-link to="/yjj/map" >
            <van-icon name="location" color="rgb(184,134,97)" size="2rem"  style="border: 2px solid rgb(184,134,97);border-radius: 50%;padding:5px;" />
            <p style="margin-top: 5px;">地图导览</p>
          </router-link>
        </div>
      </div>
    </div>

    <div style="background:rgb(245,245,245);height:15px;">
    </div>

    <div class="container" >
      <!--  新闻页面  -->
      <div class="news-col" >
        <h3 class="news-nav-title">
          <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
          <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
          最新资讯
          <span style="position: absolute;right: 10px;font-size: 12px;background:#C40909;padding:5px 15px;border-radius: 5px;">
            <router-link :to="{name:'NewsListYjj',params:{nav:'jianjie'}}" style="color:white;">更多</router-link>
          </span>
        </h3>
        <ul v-for="(item,index) in newsList" :key="item.index"  style="margin-top:10px;">
          <li class="news-list" v-if="index>=0&&index<=5" >
            <div class="news-list-img">
              <img :src="item.imgsrc">
            </div>
            <div class="news-list-title">
              <p><router-link :to="{name:'ArticleContentYjj',params:{id:item.id,prevNav:'HomeYjj'}}">{{item.title}}</router-link></p>
              <p>{{ item.abstr }}</p>
              <p>{{item.createTime | dataFormat('yyyy-mm-dd')}}</p>
            </div>
          </li>
        </ul>
      </div>



      <!--  广告栏  -->
      <div class="banner">
        <img src="../../../assets/banner.jpg" style="height:80px;">
      </div>



      <!--  陈列展览    -->
      <div style="margin-top: 20px">
        <h3 class="news-nav-title">
          <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
          <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
          陈列展览
          <span style="position: absolute;right: 10px;font-size: 12px;background:#C40909;padding:5px 15px;border-radius: 5px;">
            <router-link :to="{name:'DisplayListYjj',params:{nav:'jianjie'}}" style="color:white;">更多</router-link>
          </span>
        </h3>
        <div style="margin-top:10px;">
          <router-link :to="{name:'DisplayListYjj',params:{nav:'zhanlan'}}">
            <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/535743534448252741.jpg" alt="">
          </router-link>
        </div>
      </div>
      <!--  烽火岁月  -->
      <div style="margin-top: 30px">
        <h3 class="news-nav-title">
          <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
          <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
          烽火岁月
          <span style="position: absolute;right: 10px;font-size: 12px;background:#C40909;padding:5px 15px;border-radius: 5px;">
            <router-link :to="{name:'ResearchListYjj',params:{nav:'jianjie'}}" style="color:white;">更多</router-link>
          </span>
        </h3>
        <div>
          <ul style="line-height: 35px">
            <li style="padding-left: 10px;border-bottom: 1px #b0b0b0 dashed" v-for="item in fenghuoList" :key="item.index">
              <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">
                {{item.title}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!--  英烈风采  -->
      <div style="margin-top: 30px">
        <h3 class="news-nav-title">
          <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
          <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
          英烈风采
          <span style="position: absolute;right: 10px;font-size: 12px;background:#C40909;padding:5px 15px;border-radius: 5px;">
            <router-link :to="{name:'ResearchListYjj',params:{nav:'jianjie'}}" style="color:white;">更多</router-link>
          </span>
        </h3>
        <div>
          <ul style="line-height: 35px">
            <li style="padding-left: 10px;border-bottom: 1px #b0b0b0 dashed" v-for="item in yinglieList" :key="item.index">
              <router-link :to="{name:'ArticleContentYjj',params:{id:item.id}}" target="_blank">
                {{item.title}}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- 文物展示 -->
      <div style="margin-top: 30px">
        <h3 class="news-nav-title" >
          <span style="border-right: 1px solid #C40909;margin-right: 2px;"></span>
          <span style="border-right: 3px solid #C40909;margin-right: 5px;"></span>
          馆藏文物
          <span style="position: absolute;right: 10px;font-size: 12px;background:#C40909;padding:5px 15px;border-radius: 5px;">
            <router-link :to="{name:'CulturalListYjj',params:{nav:'jianjie'}}" style="color:white;">更多</router-link>
          </span>
        </h3>
        <div class="wenwu-list" style="margin-top: 10px;">
          <div class="wenwu-list-col" v-for="(item,index) in displayList" :key="item.index">
            <div v-if="index>=0&&index<=5" @click="open(item.imgsrc)">
              <img :src="item.imgsrc" alt="">
              <p>{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{'handler':showBox,'hider':hideBox}" @click="showKai('hide')">
      <div class="box">
        <h3 style="padding-bottom: 20px;" v-if="this.yjjdata.state == 1">当前状态:   <span style="color:#42b983;">纪念馆正常开放</span></h3>
        <h3 style="padding-bottom: 20px;" v-if="this.yjjdata.state == 0">当前状态:   <span style="color:#9E1A28;">{{yjjdata.closereason}}</span></h3>
        <hr>
        <p style="margin-top: 10px;" v-if="this.yjjdata.state == 1">纪念馆免费开放，请持本人身份证，在前台处登记入馆。</p>
        <p style="margin-top: 10px;" v-if="this.yjjdata.state == 0">正常开放后，请持本人身份证，在前台处登记入馆。服务咨询电话：024-4888908</p>
      </div>
    </div>

    <!-- 底部模板 -->
    <footer-yjj-m></footer-yjj-m>
  </div>
</template>

<script>
import HeaderYjjM from "@/components/yjj/mobile/HeaderYjjM";
import FooterYjjM from "@/components/yjj/mobile/FooterYjjM";
import {request} from "@/request/request";
// import { ImagePreview } from "vant";


export default {
  name: "HomeYjjM",
  components: {
    HeaderYjjM,
    FooterYjjM,

  },
  data(){
    return {
      newsList:[],
      noticeList:[],
      fenghuoList:[],
      yinglieList:[],
      displayList:[],
      yjjdata:{},
      showBox: false,
      hideBox:true,
      restfulUrl:'articles',

    }
  },
  methods:{
    open(item){
      console.log(item);
      // ImagePreview(['https://img01.yzcdn.cn/vant/apple-1.jpg']);
    },
    showKai:function(data){
      if(data=='hide'){
        this.showBox = false;
        this.hideBox = true;
      }
      else{
        this.showBox = true;
        this.hideBox = false;
      }
    },
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl+'/yjjhomenewslist',
      }).then(res =>{
        this.newsList = res.data;
      },err=>{
        console.log(err)
      })
    },
    getDataByColumn:function (columnIdData) {
      request({
        method:'POST',
        url:this.restfulUrl+'/getbycolumn',
        data:{columnId:columnIdData}
      }).then(res =>{
        if(columnIdData == 4){
          this.noticeList=res.data;
        }
        if(columnIdData == 12){
          this.fenghuoList = res.data;
        }
        if(columnIdData == 13){
          this.yinglieList = res.data;
        }
      },err=>{
        console.log(err)
      })
    },
    getListByColumn(column){
      request({
        method:'POST',
        url:'cultural/getcolumn',
        data:{columnId:column}
      }).then(res =>{
        for(var i=0;i<res.data.length;i++){
          if(i<=5){
            this.displayList.push(res.data[i]);
          }
        }
      },err=>{
        console.log(err)
      })
    },
    getYjjData:function (){
      request({
        method:'GET',
        url:"/yjjstate",
      }).then(res =>{
        this.yjjdata = res.data[0];
        var today = this.getWeekDay();
        var nowTimeH = this.getNowTimeH();
        var nowTimeM = this.getNowTimeM();
        if(this.yjjdata.state == 1){
          if(this.yjjdata.forcestate == 0){
            if(today == 1){
              this.yjjdata.state = 0;
              this.yjjdata.closereason = '周一例行闭馆维护';
            }
            else if((nowTimeH>=16 && nowTimeH<24) || (nowTimeH>=0 && nowTimeH<9)){
              this.yjjdata.state = 0;
              this.yjjdata.closereason = '闭馆时间';
            }
            else if(nowTimeH == 15 && nowTimeM>=30){
              this.yjjdata.state = 0;
              this.yjjdata.closereason = '停止入馆时间';
            }
          }
        }
      },err=>{
        console.log(err)
      })
    },
    getWeekDay:function (){
      var now = new Date();
      var weekday = now.getDay();
      return weekday;
    },
    getNowTimeH:function(){
      var now = new Date();

      var time = now.getHours();
      return time;
    },
    getNowTimeM:function(){
      var now = new Date();

      var time = now.getMinutes();
      return time;
    },
  },
  mounted() {
    this.getData();
    this.getYjjData();
    this.getDataByColumn(4);
    this.getDataByColumn(12);
    this.getDataByColumn(13);
    this.getListByColumn(1);
  },
  filters:{
    dataFormat(input,pattern=''){
      var dt = new Date(input);
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, '0');
      var d = dt.getDate().toString().padStart(2, '0');
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0');
        var mm = dt.getMinutes().toString().padStart(2, '0');
        var ss = dt.getSeconds().toString().padStart(2, '0');
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    }
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }

}
</script>

<style scoped>
body{
  background: #e5e5e5;
}
a{
  color: black;
  text-decoration: none;
}
li{
  list-style: none;
  text-align: left;
}
img{
  width: 100%;
}
.container{
  padding: 10px;
}
.slide-img{
  width:100%;
  overflow: hidden;
}
.slide-img img{
  width: 100%;
}

.news-col{

}
.news-nav-title{
  text-align: left;
  color: black;
  margin: 10px 0 5px;
  padding-left: 5px;
}

.news-col .news-list{
  display: flex;
  margin: 5px 0;
}
.news-col .news-list-img{
  flex: 2;
}
.news-col .news-list-img img{
  height:80px;
  padding-right: 5px;
}
.news-col .news-list-title{
  flex:5;
  padding: 6px 0 5px 10px;
  overflow: hidden;
}
.news-col .news-list-title p{
  color:#666;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  line-height: 23px;
}
.news-col .news-list-title p a{
  font-size: 16px;
  font-weight: bold;
}
.wenwu-list{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.wenwu-list-col{
  width: calc((100% - 10px) / 2);
  min-width: calc((100% - 10px) / 2);
  max-width: calc((100% - 10px) / 2);
}


.wenwu-list-col:nth-child(2),.wenwu-list-col:nth-child(4),.wenwu-list-col:nth-child(6){
  padding-left: 5px;
}


.wenwu-list-col:nth-child(1),.wenwu-list-col:nth-child(3),.wenwu-list-col:nth-child(5){
  padding-right: 5px;
}



.wenwu-list-col img{

  width:100%;
  height:120px;

}


.wenwu-list-col p{
  color:#666;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-all;
  line-height: 23px;
}


.handler {
  position: fixed;
  z-index: 2000;
  width:100%;
  height: 100%;
  min-height:2000px;
  top: 0;
  left: 0;
  box-sizing: border-box;
  transition: transform 1s ease-in-out;
  /*transform: fade;*/
  background:rgba(10,10,10,0.7);
}

.hider{

  display: none;

}

.box{

  width:75%;
  height:100px;
  padding:40px 20px 40px 20px;
  position: relative;
  background: white;
  top:20%;
  margin: 0 auto;
  border-radius: 10px;

}


</style>
